import { render, staticRenderFns } from "./SimpleAuthenticationType.vue?vue&type=template&id=48025244&"
import script from "./SimpleAuthenticationType.vue?vue&type=script&lang=js&"
export * from "./SimpleAuthenticationType.vue?vue&type=script&lang=js&"
import style0 from "./SimpleAuthenticationType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports